/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: formDefaults.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Default values for User Profile form.

 🔁 Last Updated: 2025-01-XX by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import type { UserProfileData } from '../types';

/**
 * Default form values for User Profile
 */
export const DEFAULT_USER_PROFILE_DATA: UserProfileData = {
  username: '',
  email: '',
  fullName: '',
  department: '',
  locale: 'es',
  timezone: 'UTC',
  startupDialog: '/dashboard',
  startModuleUrl: undefined,
  debugModeActive: false
};

